import { render, staticRenderFns } from "./OverviewOrderMarkAsBeingShipped.vue?vue&type=template&id=179a462a&scoped=true&"
import script from "./OverviewOrderMarkAsBeingShipped.vue?vue&type=script&lang=js&"
export * from "./OverviewOrderMarkAsBeingShipped.vue?vue&type=script&lang=js&"
import style0 from "./OverviewOrderMarkAsBeingShipped.vue?vue&type=style&index=0&id=179a462a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a462a",
  null
  
)

export default component.exports